import { Component, Input, OnInit, inject } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import {
  BackgroundColorEnum,
  BoelsTeaserComponentData,
  CardsGroupComponentData,
  CmsComponentData,
} from '@boels/models';
import { CardComponent } from './card/card.component';
import { CommonModule } from '@angular/common';
import { SafeCheckPipe } from '@boels/helpers';
import { ComponentDataService } from '@boels/shared-state';
import { VerticalAlignerComponent } from '../../vertical-aligner/vertical-aligner.component';

@Component({
  imports: [
    CommonModule,
    CardComponent,
    SafeCheckPipe,
    VerticalAlignerComponent,
  ],
  selector: 'boels-cards-group',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss'],
})
export class CardsComponent implements OnInit {
  private componentDataService = inject(ComponentDataService);

  backgroundColor = BackgroundColorEnum;
  @Input() componentData: CmsComponentData<CardsGroupComponentData>;
  cards$: Observable<BoelsTeaserComponentData[]>;

  ngOnInit() {
    this.cards$ = this.componentData.data$.pipe(
      switchMap((data) => this.componentDataService.getCMSChildrenData(data)),
    );
  }
}
